import { node } from "~/util/dom";
import { createRouteClearButton } from "./clear";
import ParamsItem from "./item";
import { getItem } from "~/es6/localstorage";
import { store } from "~/route/globals";
import { selectUserSettingsValue } from "~/state/user/selectors";
import { ESETTINGS_KEYS } from "~/state/user/interfaces";
import { ROUTE_CONST } from "~/route/const";
import { getTypeFromCriterion } from "~/route/utils";

export default class RouteParams {
	_container: HTMLDivElement;

	_containerItems: HTMLDivElement;

	_subContainer: HTMLDivElement;

	_clear: HTMLSpanElement | SVGSVGElement;

	_lastBuildType: string;

	_typesItems: Array<ParamsItem>;

	_circuitItems: Array<ParamsItem>;

	_lids: Array<string>;

	_azimuth: HTMLInputElement;

	constructor() {
		this._container = node("div", { className: "route-params" });
		this._containerItems = node("div", { className: "route-buttons" });
		this._subContainer = node("div", { className: "route-type-params" });
		this._clear = null;
		this._lastBuildType = "";
		this._typesItems = [];
		this._circuitItems = [];
		this._container.appendChild(this._containerItems);
		this._container.appendChild(this._subContainer);

		this._build();
		this._setItems();

		this._lids = [Mapy.CML.addListener((responseData, state) => {
			const type = state && state.route.items?.length && state.route.items[0].tripData && state.route.items[0].tripData[Mapy.CML.state.route.index || 0] ? "circuit" : "items";

			this._setItems(type);
			if (responseData[state.route.index]) {
				this._container.appendChild(this._clear);
			} else {
				this._clear.remove();
			}
		}, "route.responseData"),
		Mapy.CML.addListener(items => {
			if (items.length === 1 && items[0].planTrip) {
				this._setItems("circuit");
			} else {
				this._setItems("items");
			}
		}, "route.items"),
		Mapy.CML.addListener(error => {
			if (error) {
				this._container.appendChild(this._clear);
			}
		}, "route.error"),
		Mapy.CML.addListener(params => {
			this._typesItems.forEach(item => {
				item.state = params;
			});
			this._circuitItems.forEach(item => {
				item.state = params;
			});
		}, "route.params")];
	}

	destroy() {
		Mapy.CML.removeListeners(this._lids);
		this._container.remove();
	}

	get container() {
		return this._container;
	}

	get azimuth() {
		return this._azimuth.value;
	}

	// eslint-disable-next-line class-methods-use-this
	get defaultState() {
		const localStorageCriterion = parseInt(getItem(ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION));
		const criterion = selectUserSettingsValue(store.getState(), ESETTINGS_KEYS.ROUTING_WEB_DEFAULT_CRITERION) || localStorageCriterion || ROUTE_CONST.types.car.criterion[0];
		const routeType = getTypeFromCriterion(parseInt(criterion)) || ROUTE_CONST.TYPE_CAR;

		return {
			params: {
				criterion, // defaultni kriterium
				type: routeType,
				excludeCountries: [],
				tripIndex: 0, // pro vylet
				tripCriterion: ROUTE_CONST.circuitTypes.trial.def,
				waypoints: "",
				datetime: "",
				mobile: false,
				departure: true,
				useTraffic: true,
				avoidHighways: false,
				allowViaFerrata: false,
			},
		};
	}

	_build() {
		let types = Object.keys(ROUTE_CONST.types);

		types.forEach(type => {
			const typeDef = ROUTE_CONST.types[type];
			const typeItem = new ParamsItem(typeDef, false);

			this._typesItems.push(typeItem);

			if (typeDef.subItems && typeDef.subItems.length) {
				this._subContainer.appendChild(typeItem.container);
			}
		});

		types = Object.keys(ROUTE_CONST.circuitTypes);

		types.forEach(type => {
			const typeDef = ROUTE_CONST.circuitTypes[type];
			const typeItem = new ParamsItem(typeDef, true);

			this._circuitItems.push(typeItem);
		});

		this._clear = createRouteClearButton();

		// azimut
		this._azimuth = node("input", { type: "number", min: "0", max: "359" });
		if (Mapy.CUS.route?.azimuth) {
			const label = node("label", { innerHTML: "azimut: " });

			label.appendChild(this._azimuth);
			this._subContainer.appendChild(label);
			this._azimuth.addEventListener("change", () => {
				Mapy.CML.state = {
					route: {
						forced: true,
					},
				};
			});
		}
	}

	_setItems(type = "items") {
		if (this._lastBuildType !== type) {
			this._lastBuildType = type;

			while (this._containerItems.firstChild) {
				this._containerItems.firstChild.remove();
			}

			const source = type === "circuit" ? this._circuitItems : this._typesItems;

			source.forEach(item => {
				this._containerItems.appendChild(item.button);
			});
		}
	}
}
